// RoleSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { RoleState } from './roleType';
import { createRole, updateRole, deleteRole, fetchRoleById, fetchAllRoles } from './roleAction';

// Initial State
const initialState: RoleState = {
    roles: [],
    selectedRole: undefined,
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
};

// Slice
const roleSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Role
            .addCase(createRole.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createRole.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.roles.push(action.payload);
            })
            .addCase(createRole.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Update Role
            .addCase(updateRole.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(updateRole.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.roles.findIndex((role) => role.RoleId === action.payload.RoleId);
                if (index !== -1) {
                    state.roles[index] = action.payload;
                }
            })
            .addCase(updateRole.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete Role
            .addCase(deleteRole.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(deleteRole.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.roles = state.roles.filter((role) => role.RoleId !== action.payload.RoleId);
            })
            .addCase(deleteRole.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            })

            // Fetch Role by ID
            .addCase(fetchRoleById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(fetchRoleById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedRole = action.payload;
            })
            .addCase(fetchRoleById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Fetch All Roles
            .addCase(fetchAllRoles.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllRoles.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.roles = action.payload.data;
            })
            .addCase(fetchAllRoles.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            });
    },
});

export default roleSlice.reducer;
